import { DEFAULT_CURRENCY_CODE } from '@ofmos/shared/field-types';
import { Input, SelectMenu } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { currencyUnits, unitsToMicros } from '../format';

/**
 * Amount and code are edited together because they are stored together
 * (field-types.md decision 4). The amount is entered in units and converted to
 * exact micros on the way in: no float ever reaches storage.
 */
const CODES = ['EUR', 'USD', 'GBP', 'CHF'] as const;

export function CurrencyInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  const composite =
    value !== null && typeof value === 'object' && 'amountMicros' in value ? value : null;
  const code =
    composite?.currencyCode ?? field.options?.defaultCurrencyCode ?? DEFAULT_CURRENCY_CODE;

  return (
    <div className="flex items-center gap-2">
      <Input
        type="number"
        inputMode="decimal"
        step="0.01"
        value={composite === null ? '' : String(currencyUnits(composite))}
        onChange={(event) =>
          onChange(
            event.target.value === ''
              ? null
              : { amountMicros: unitsToMicros(Number(event.target.value)), currencyCode: code },
          )
        }
        disabled={readOnly}
        aria-label={`${field.label} amount`}
        className="tabular-nums"
      />
      {/* The code column's width is this field's layout, not the select's (D1). */}
      <div className="w-28">
        <SelectMenu
          value={code}
          onValueChange={(nextCode) =>
            onChange({ amountMicros: composite?.amountMicros ?? 0, currencyCode: nextCode })
          }
          options={CODES.map((entry) => ({ value: entry, label: entry }))}
          disabled={readOnly}
          ariaLabel={`${field.label} currency`}
        />
      </div>
    </div>
  );
}
